import React, { useCallback, useEffect, useState } from 'react';
import { getFileSize } from 'Util/FileUtils';

const FileSizeArea = ({ file }) => {
  const [fileSize, setFileSize] = useState(null);

  const _getFileSize = useCallback(async () => {
    const size = await getFileSize(file);
    setFileSize(size);
  }, [file]);

  useEffect(() => {
    _getFileSize();
  }, [_getFileSize]);

  return <div className='customer-support-chat-item-content-attachment-text-size'>{fileSize}</div>;
};

export default FileSizeArea;
